export default import.meta.ROLLUP_FILE_URL_5T1$egcYVvpPEuAoOBbyuA